import React, { useState } from 'react'
import { Query } from 'react-apollo'
import {
  Row, Col, Divider, DatePicker, Badge, Select, Modal,
} from 'antd'
import moment from 'moment'
import FileDownload from 'js-file-download'
import axios from 'axios'
import _ from 'lodash'
import { useQuery } from '@apollo/react-hooks'
import ReactTable from 'react-table'
import {
  Div, H3, Loading, P, DynamicButtonLink, H4, Button,
} from 'konsys-ui'
import config from './config'
import { theme } from '../../../styles/_variables'
import { MYINFO } from '../../../constants/graph/query'
import { GET_REPAIR_JOBS, GET_FLEETS } from '../../../constants/graphql/query'
import './style-css.css'
import { Wrapper } from '../../../components/repair-job-components'
import PERMISSION from '../../../constants/permissions'
import { getAccessToken, getURL } from '../../../utils/local-data-service'
import { status, servicesStatus, servicesStatusText } from '../constants'

const { color } = theme

const colorSelector = (val) => {
  switch (val) {
    case status.WAITING:
      return color.coolGrey
    case status.INPROGRESS:
      return color.info
    case status.CANCEL:
      return color.error
    case status.COMPLETED:
      return color.success
    case status.NOTIFY:
      return color.charcoalGrey
    default:
      return color.primaryColor
  }
}

export const badgeColorSelector = (val) => {
  switch (val) {
    case servicesStatus.WAITING:
      return 'default'
    case servicesStatus.ASSIGNED:
      return 'warning'
    case servicesStatus.CANCEL:
      return 'error'
    case servicesStatus.STARTED:
      return 'processing'
    case servicesStatus.DONE:
      return 'success'
    case servicesStatus.NOTIFY:
      return 'default'
    default:
      return 'default'
  }
}

export const servicesTextSelector = (val) => {
  switch (val) {
    case servicesStatus.WAITING:
      return servicesStatusText.WAITING
    case servicesStatus.ASSIGNED:
      return servicesStatusText.ASSIGNEDß
    case servicesStatus.CANCEL:
      return servicesStatusText.CANCEL
    case servicesStatus.STARTED:
      return servicesStatusText.STARTED
    case servicesStatus.DONE:
      return servicesStatusText.DONE
    case servicesStatus.NOTIFY:
      return servicesStatusText.NOTIFY
    default:
      return 'ไม่ระบุ'
  }
}

const GarageReportModal = ({
  garageReportModal, setGarageReportModal, isLoading, setIsLoading,
}) => {
  const [range, setRange] = useState([])
  return (
    <Modal
      title="พิมพ์รายงานแจ้งซ่อมจากอู่นอก"
      visible={garageReportModal}
      destroyOnClose={true}
      onCancel={() => {
        setGarageReportModal(false)
        setRange([])
      }}
      onOk={() => {
        setIsLoading(true)
        axios({
          method: 'GET',
          responseType: 'blob',
          headers: {
            Authorization: `Bearer ${getAccessToken()}`,
          },
          url: `${getURL().FILE_SERVER}/download/excel/repairjob/outsource?startDate=${moment(range[0]).format('YYYY-MM-DD')}&endDate=${moment(range[1]).format('YYYY-MM-DD')}`,
        }).then((resp) => {
          FileDownload(resp.data, `รายงานการแจ้งซ่อมจากอู่นอก ณ วันที่ ${moment(range[0]).format('YYYY-MM-DD')} ถึงวันที่ ${moment(range[1]).format('YYYY-MM-DD')}.xlsx`)
          setGarageReportModal(false)
          setRange([])
          setIsLoading(false)
        })
      }}
      okButtonProps={{
        disabled: isLoading,
        loading: isLoading,
      }}
      cancelButtonProps={{
        disabled: isLoading,
      }}
    >
    <Div display='flex' justifyContent='space-between' alignItems='center' flexDirection='row'>
      <P margin='16px 0'>เลือกวันที่</P>
      <DatePicker.RangePicker
        format='DD/MM/YYYY'
        onChange={(e) => {
          setRange(e)
        }}
      />
      </Div>
    </Modal>
  )
}

const TireOutReportModal = ({
  tireOutReportModal, setTireOutReportModal, isLoading, setIsLoading,
}) => {
  const [range, setRange] = useState([])
  const [fleet, setFleet] = useState('')
  const {
    loading, data, error, refetch,
  } = useQuery(GET_FLEETS)
  if (loading || _.isEmpty(data)) return <Loading />
  return (
    <Modal
      title="พิมพ์รายงานเปลี่ยนยางออก"
      visible={tireOutReportModal}
      destroyOnClose={true}
      onCancel={() => {
        setTireOutReportModal(false)
        setRange([])
        setFleet('')
      }}
      onOk={() => {
        setIsLoading(true)
        axios({
          method: 'GET',
          responseType: 'blob',
          headers: {
            Authorization: `Bearer ${getAccessToken()}`,
          },
          url: `${getURL().FILE_SERVER}/download/excel/tires/returntires?startDate=${moment(range[0]).format('YYYY-MM-DD')}&endDate=${moment(range[1]).format('YYYY-MM-DD')}&fleetId=${fleet}`,
        }).then((resp) => {
          FileDownload(resp.data, `รายงานเปลี่ยนยางออก ณ วันที่ ${moment(range[0]).format('YYYY-MM-DD')} ถึงวันที่ ${moment(range[1]).format('YYYY-MM-DD')} ของfleet ${fleet || 'ทั้งหมด'}.xlsx`)
          setTireOutReportModal(false)
          setRange([])
          setFleet('')
          setIsLoading(false)
        })
      }}
      okButtonProps={{
        disabled: isLoading,
        loading: isLoading,
      }}
      cancelButtonProps={{
        disabled: isLoading,
      }}
    >
    <Div display='flex' justifyContent='space-between' alignItems='center' flexDirection='row'>
      <P margin='16px 0'>เลือกวันที่</P>
      <DatePicker.RangePicker
        format='DD/MM/YYYY'
        onChange={(e) => {
          setRange(e)
        }}
      />
      </Div>
      <Div display='flex' justifyContent='space-between' alignItems='center' flexDirection='row'>
      <P margin='16px 0'>เลือก Fleet</P>
      <Select
        style={{ width: 334 }}
        defaultValue="ทั้งหมด"
        onSelect={(e) => {
          if (e === 'all') {
            setFleet('')
          } else {
            setFleet(e)
          }
        }}
      >
        <Select.Option key='all' value='all'>ทั้งหมด</Select.Option>
        {
          data.FleetList.lists.map(v => <Select.Option key={v.id} value={v.id}>{v.name}</Select.Option>)
        }
      </Select>
      </Div>
    </Modal>
  )
}

const Index = () => {
  const [date, setDate] = useState(moment())
  const [warehouse, setWarehouse] = useState()
  const [isLoading, setIsLoading] = useState()
  const [garageReportModal, setGarageReportModal] = useState(false)
  const [tireOutReportModal, setTireOutReportModal] = useState(false)
  const {
    data: myInfo, loading, error, fetchMore, refetch,
  } = useQuery(MYINFO)
  if (loading || _.isEmpty(myInfo)) return <Loading center='true' />
  return (
    <Div display='flex' flexDirection='column'>
      <Div display='flex' flexDirection='row' justifyContent='space-between' alignItems='center'>
        <H3 bold color={color.primaryColor} margin='32px 0'>ใบแจ้งซ่อม</H3>
        <Div>
        <Button
            text='พิมพ์รายงานเปลี่ยนยางออก'
            icon='fas fa-print'
            onClick={() => {
              setTireOutReportModal(true)
            }}
            margin='0 16px 0 0'
          />
        <Button
            text='พิมพ์รายงานแจ้งซ่อมอู่นอก'
            icon='fas fa-print'
            onClick={() => {
              setGarageReportModal(true)
            }}
            margin='0 16px 0 0'
          />
        <DynamicButtonLink link='/repair-job/add' condition={_.includes(window.perms, PERMISSION.CREATE_REPAIR)} props={{ text: 'สร้างใบแจ้งซ่อม' }} />
        </Div>
      </Div>
      <Div display='flex' flexDirection='row' justifyContent='center' alignItems='center' margin='0 0 24px 0'>
        <Div>
          <P margin='0 8px 0'>ข้อมูลเดือน</P>
          <DatePicker.MonthPicker defaultValue={moment()} onChange={e => setDate(e)} allowClear={false} />
          <P margin='0 8px 0'>เลือกสาขา</P>
          <Select
            style={{ width: 150 }}
            defaultValue="ทั้งหมด"
            onSelect={(e) => {
              if (e === 'all') {
                setWarehouse()
              } else {
                setWarehouse(e)
              }
            }}
          >
            <Select.Option key='all' value='all'>ทั้งหมด</Select.Option>
            {
              myInfo.myInfo.Warehouses.map(v => <Select.Option key={v.id} value={v.id}>{v.warehouseName}</Select.Option>)
            }
          </Select>
          </Div>
        </Div>
      <List date={date} warehouse={warehouse} />
      <GarageReportModal
      garageReportModal={garageReportModal}
      setGarageReportModal={setGarageReportModal}
      isLoading={isLoading}
      setIsLoading={setIsLoading}
      />
      <TireOutReportModal
      tireOutReportModal={tireOutReportModal}
      setTireOutReportModal={setTireOutReportModal}
      isLoading={isLoading}
      setIsLoading={setIsLoading}
      />
    </Div>
  )
}

export const List = ({ date, warehouse }) => {
  const [current, setCurrent] = useState(0)
  const [sorted, setSorted] = useState([{ id: 'id', desc: true }])
  const [filtered, setFiltered] = useState([])

  return (
    <Wrapper overflow padding='0 0 40px 0'>
      <Query
        query={GET_REPAIR_JOBS}
        fetchPolicy='cache-and-network'
        variables={{
          limit: 5,
          offset: current * 5,
          createdAt: date.format(),
          orderBy: sorted[0].desc ? 'DESC' : 'ASC',
          orderField: sorted[0].id,
          warehouseId: warehouse,
          ...filtered,
        }}
      >{({ data, loading, error }) => {
        if (loading && _.isEmpty(data)) return <Loading center='true' />
        if (error) return <P>เกิดข้อผิดพลาด</P>

        return (
          <Div margin='auto'>
            <ReactTable
              className='table'
              data={data.RepairJobList.lists}
              resizable={false}
              columns={config.columns}
              minRows={5}
              manual
              showPageSizeOptions={false}
              getTdProps={() => ({ disabled: true })}
              getTrProps={(state, rowInfo) => {
                if (rowInfo) {
                  return {
                    style: {
                      padding: '8px 0',
                      backgroundColor: '#ffffff',
                      borderLeft: `3px solid ${colorSelector(rowInfo.original.status)}`,
                    },
                  }
                } return {}
              }}
              previousText='ก่อนหน้า'
              nextText='ถัดไป'
              pageText='หน้า'
              ofText='จาก'
              noDataText='ไม่พบข้อมูล'
              page={current}
              pages={Math.ceil(data.RepairJobList.totalFilter / 5)}
              onPageChange={page => setCurrent(page)}
              onFilteredChange={async (newFiltered) => {
                const newOjb = {}
                await newFiltered.forEach((v) => {
                  if (v.id === 'Truck.plateNumber') {
                    Object.assign(newOjb, { plateNumber: v.value })
                  } else if (v.id === 'CreatedBy.fullname') {
                    Object.assign(newOjb, { fullname: v.value })
                  } else if (v.id === 'Truck.owner.nameTh') {
                    Object.assign(newOjb, { truckOwner: v.value })
                  } else Object.assign(newOjb, { [v.id]: v.value })
                })
                setCurrent(0)
                setFiltered(newOjb)
              }}
              onSortedChange={async (newSorted) => {
                setSorted(newSorted)
                setCurrent(0)
              }}
              SubComponent={(props) => {
                const mappedServices = props.original.services.map(v => ({
                  id: v.id,
                  department: v.status !== servicesStatus.WAITING ? v.Mechanic.department : 'รอการจ่ายงาน',
                  mechanic: v.status !== servicesStatus.WAITING ? v.Mechanic && !_.isNull(v.Mechanic.firstname) && !_.isNull(v.Mechanic.lastname) ? `${v.Mechanic.firstname} ${v.Mechanic.lastname}` : 'ไม่มีการจ่ายงาน' : 'รอการจ่ายงาน',
                  status: v.status,
                }))
                return (
                  <Div display='flex' flexDirection='column' margin='0 0 0 3px' padding='8px 40px 40px' style={{ backgroundColor: '#fff', borderRadius: '0 0 32px 32px' }}>
                    <Row>
                      <Col offset={1} span={4}><P textAlign='center' bold display='block'>งานซ่อม</P></Col>
                      <Col span={5}><P textAlign='center' bold display='block'>แผนก</P></Col>
                      <Col span={6}><P textAlign='center' bold display='block'>ช่างที่ซ่อม</P></Col>
                      <Col span={5}><P textAlign='center' bold display='block'>สถานะ</P></Col>
                      <Col span={2}><P textAlign='center' bold display='block'>Ref id.</P></Col>
                    </Row>
                    <Divider style={{ margin: '8px 0' }} />
                    {
                      _.size(mappedServices) > 0
                        ? mappedServices.map((v, i) => (
                          <Row key={v.id} type='flex' align='middle'>
                            <Col offset={1} span={4}><P textAlign='center' margin='8px 0' display='block'>{i + 1}</P></Col>
                            <Col span={5}><P margin='8px 0 8px 40px'>{v.department}</P></Col>
                            <Col span={6}><P margin='8px 0 8px 40px'>{v.mechanic}</P></Col>
                            <Col span={5}>
                              <Badge style={{ marginLeft: '40px' }} status={badgeColorSelector(v.status)} text={servicesTextSelector(v.status)} />
                              {/* <P margin='8px 0' color={servicesColorSelector(v.status)} bold>{servicesTextSelector(v.status)}</P> */}
                            </Col>
                            <Col span={2}><P margin='8px 0 8px 40px' color={color.coolGrey}>#{v.id}</P></Col>
                          </Row>
                        ))
                        : <H4 style={{ alignSelf: 'center' }} margin='20px 0 0' bold color={color.purplishGrey}>ไม่พบงานซ่อม</H4>
                    }
                  </Div>
                )
              }}
            />
            {
              loading && <Div margin='32px 0 0'><Loading center='true' /></Div>
            }
          </Div>
        )
      }}
      </Query>
    </Wrapper>
  )
}

export default Index
